export default __webpack_public_path__ + "static/media/8D38CCA7-823F-4200-84E6-47C90BFC69B3_1_105_c.c59bfdd4.jpeg";